import { SelectionModel } from '@angular/cdk/collections';
import { LOCALE_ID, Component, ViewEncapsulation, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { TableColumn } from 'app/components/mat-custom-table/tableColumn';
import { PagareResumen } from 'app/models/pagare.model';
import moment from 'moment';
import { ReporteForm24Service } from '../../../../services/reportes-form-24';

export interface ResumenImpuesto {
    CONCEPTO: string;
    CODIGO: string;
    IMPUESTO: string;
}

export interface Resumen {
    TOTAL: number;
    NULOS: number;
    VALIDOS: number;
    MONTO_TOTAL: number;
}

@Component({
    selector: 'formulario',
    templateUrl: './formulario.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./formulario.component.scss']
})
export class FormularioComponent {
    datasourceForm24: any = [];
    periods: any = [];
    pagareResumen: Resumen;
    pagareResumenDataSource: Resumen[] = [];
    resumenImpuestoDataSource: ResumenImpuesto[] = [];
    value: number = 10000;
    selectPeriod = 0;
    foliosValidos = '';
    concepto = 'LETRA DE CAMBIO, PAGARÉS, LIBRANZAS, CRÉDITOS, ETC. (ART. 1º, Nº 3 D.L. 3.475)';
    codigo = '213';

    constructor(@Inject(LOCALE_ID) private locale: string, private route: Router, private reporteForm24Service: ReporteForm24Service) { }
    ngOnInit() {

        this.obtenerParametros();
        //const today = moment().locale(this.locale);
        const today = moment().locale('es-CL');
        this.periods = [
            { value: 0, viewValue: today.add(0, 'M').format('MMMM YYYY') },
            { value: -1, viewValue: today.add(-1, 'M').format('MMMM YYYY') },
            { value: -2, viewValue: today.add(-1, 'M').format('MMMM YYYY') },
        ];
        this.obtenerPagareResumen();
    }


    columns: TableColumn[] = [
        { columnDef: 'CONCEPTO', header: 'CONCEPTO', headerClass: "px-1.5", columnClass: "px-1.5 paragraph-5", columnClassMobile: 'paragraph-4', columnType: "string", columnFormat: "", columnSort: true },
        { columnDef: 'CODIGO', header: 'CODIGO', headerClass: "px-1.5", columnClass: "px-1.5 paragraph-5 text-center", columnClassMobile: 'paragraph-4', columnType: "string", columnFormat: "", columnSort: true },
        { columnDef: 'IMPUESTO', header: 'IMPUESTO', headerClass: "px-1.5", columnClass: "px-1.5 paragraph-5 text-center", columnClassMobile: 'paragraph-4', columnType: "currency", columnFormat: "CLP", columnSort: true },

    ]

    columnsResumen: TableColumn[] = [
        { columnDef: 'TOTAL', header: 'Total pagarés', headerClass: "px-1.5 uppercase", columnClass: "px-1.5 paragraph-5 text-center", columnClassMobile: 'paragraph-4', columnType: "number", columnFormat: "", columnSort: true },
        { columnDef: 'NULOS', header: 'nulos', headerClass: "px-1.5 uppercase", columnClass: "px-1.5 paragraph-5 text-center", columnClassMobile: 'paragraph-4', columnType: "number", columnFormat: "", columnSort: true },
        { columnDef: 'VALIDOS', header: 'emitidos', headerClass: "px-1.5 uppercase", columnClass: "px-1.5 paragraph-5 text-center", columnClassMobile: 'paragraph-4', columnType: "number", columnFormat: "", columnSort: true },
        { columnDef: 'MONTO_TOTAL', header: 'monto', headerClass: "px-1.5 uppercase", columnClass: "px-1.5 paragraph-5 text-center", columnClassMobile: 'paragraph-4', columnType: "currency", columnFormat: "CLP", columnSort: true },

    ]


    obtenerParametros() {
        this.reporteForm24Service.getParametros().subscribe({
            next: (data) => {
                this.datasourceForm24 = data;
            },
            error: (err: any) => {
                console.log(err);
                this.datasourceForm24 = [];
            },
            complete: () => { },
        });
    }
    changePeriod() {
        this.obtenerPagareResumen();
    }

    obtenerPagareResumen() {

        const fecha_inicial = moment().add(this.selectPeriod, 'M').startOf('month').format('YYYY-MM-DD');
        const fecha_final = moment().add(this.selectPeriod, 'M').endOf('month').format('YYYY-MM-DD');
        console.log(fecha_inicial);


        this.reporteForm24Service.getPagaresResumen(fecha_inicial, fecha_final).subscribe({
            next: (data) => {
                this.pagareResumenDataSource = [];
                this.pagareResumenDataSource.push(data.HEADER);
                this.foliosValidos = data.HEADER.FOLIOS_VALIDOS;
                this.resumenImpuestoDataSource = [];
                this.resumenImpuestoDataSource = [{ IMPUESTO: data.HEADER.IMPUESTO_TOTAL, CONCEPTO: this.concepto, CODIGO: this.codigo }];
            },
            error: (err: any) => {
                console.log(err);
                this.pagareResumenDataSource = [];
            },
            complete: () => { },
        });
    }

    selected = '1';

    goback(): void {
        this.route.navigateByUrl('home/reportes');
    }

    documentos: string[] = [
        'Pagaré',
        'Pagaré Notariado',
        'Factura',
        'Factura',
        'Contrato',
        'Otros',
        'Otros',
        'Otros',
    ];


    displayedColumns: string[] = ['concepto', 'codigo', 'impuesto'];
    selection = new SelectionModel<any>(true, []);


    onTableAction(row: any) {
        console.log('ver detalles de', row)
        // this.route.navigateByUrl('home/judicial/detalle');

    }

}
